
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
	import FoamBoxLeftSVG from '@/components/FoamBoxLeftSVG.vue';
	import FoamBoxRightSVG from '@/components/FoamBoxRightSVG.vue';

	@Observer
	@Component({
		components: { FoamBoxRightSVG, FoamBoxLeftSVG }
	})
	export default class RightFootSVG extends Vue {}
